import * as React from "react";
import { useEffect } from "react";
import { useQuoteDetailStore } from "src/hooks/quote-detail";
import { useProductPricingStore } from "src/hooks/productPricing";
import { useProductInventoryStore } from "src/hooks/productInventory";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const ClearQuoteICarttemPopup = (props) => {
  const { SetStatus, data } = props;
  const [{}, {}, { remove_quote_cart_line_item }] = useQuoteDetailStore();
  const [{ inventoryList }, {}, {}] = useProductInventoryStore();
  const inventory = inventoryList;
  const [{ pricingList }, {}, {}] = useProductPricingStore();
  const pricing = pricingList;

  useEffect(() => {
    if (ClearQuoteICarttemPopup) {
      SetStatus(true);
    }
  }, [ClearQuoteICarttemPopup]);

  const onHide = (action = true) => {
    SetStatus(false);
  };

  const clearedLineQuoteItem = async () => {
    await remove_quote_cart_line_item(data);
    onHide();
    clearSingleQuoteEvent();
  };

  //By Ramya Kannan [Clear single quote - Adobe script ]
  function clearSingleQuoteEvent() {
    let quoteDetails = props?.data;
    let prodDetails = { ...props?.data?.product };

    prodDetails.qas = getInventory(prodDetails?.ERPPartNumber)?.qas;
    prodDetails.subtotal = quoteDetails?.subTotal_quantity_1;
    prodDetails.unitPrice = quoteDetails?.price_quantity_1;
    prodDetails.Quantity = quoteDetails?.quantity_0;
    prodDetails.priceSource = getPricing(
      prodDetails.ERPMFRPartNumber || prodDetails.erpMfrPartNumber,
      prodDetails.ERPPartNumber,
      prodDetails.ERPPartNumberModified
    )[0]?.priceSource;
    prodDetails.quoteID = quoteDetails?.quoteNumber;
    prodDetails.quoteType = "online";

    let cartDetails = {
      additionSource: "PLP",
      cartType: "Quote",
      quoteID: quoteDetails?.quoteNumber,
      quoteType: "online",
    };
    localStorage.setItem("adobeEventType", "quoteCartRemovalEvent");

    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
    }
  }

  const getInventory = (ERPPartNumber) => {
    if (inventory[ERPPartNumber] !== undefined) {
      return inventory[ERPPartNumber];
    }
    return {
      qas: 0,
      quantity: 0,
    };
  };
  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };

  return (
    <>
      <div className="avnet-modal modal-730">
        <div className="avnet-modal-inner">
          <button
            type="button"
            className="close py-3"
            data-dismiss="modal"
            onClick={() => {
              onHide();
            }}
          >
            ×
          </button>
          <div className="bs5 modal-header border-0">
            <h3 className="modal-title m-auto" id="exampleModalLabel">
              Clear Quote Item
            </h3>
          </div>
          <div className="modal-body">
            <p className="text-center">
              Once cleared you will remove this item from your Quote cart.
            </p>
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              type="button"
              className="bs5 btn btn-secondary"
              onClick={() => {
                onHide();
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="bs5 btn btn-primary"
              onClick={() => {
                clearedLineQuoteItem();
              }}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClearQuoteICarttemPopup;
